import { createReducer } from 'redux-starter-kit';
import { CustomerType } from 'store/modules/Customers/types';
import {
  FundAllocationType,
  ChargeType
} from 'store/modules/ExistingPolicies/types';
import {
  SET_POLICY,
  SET_RISK_SUMMARY,
  CLEAN_STATE,
  SET_CIP_FUNDS,
  SET_CIP_TEMPLATE
} from './actions';
import { FundType } from 'store/modules/Funds/types';
import { CaseType } from '../Case/types';

export interface InitialStateType {
  policy: {
    id: number | null;
    owner: CustomerType | null;
    number: string | null;
    type: number | null;
    provider: number | null;
    platform: number | null;
    fund_value: string | null;
    transfer_value: string | null;
    family_linked: boolean | null;
    fund_allocations: Array<FundAllocationType>;
    charges: Array<ChargeType> | null;
    advisor_charges_definitions: Array<ChargeType>;
    wrap_retained: string | null;
    wrap_percentage: string | null;
    performed_action: number | null;
  };
  riskSummary: {
    id: number | null;
    pid: string | null;
    case: CaseType | null;
    customer: CustomerType | null;
    time_horizon: number | null;
    required_return: '0.0300' | null;
    risk_tolerance: number | null;
    risk_capacity: string | null;
    knowledge_level: number | null;
    recommended_risk_profile: number | null;
    time_horizon_interval: number | null;
  };
  cipTemplate: Array<FundType>;
  cipFunds: Array<FundType>;
}

const INITIAL_STATE: InitialStateType = {
  policy: {
    id: null,
    owner: null,
    number: null,
    type: null,
    provider: null,
    platform: null,
    fund_value: null,
    transfer_value: null,
    family_linked: null,
    fund_allocations: [],
    charges: null,
    advisor_charges_definitions: [],
    wrap_retained: null,
    wrap_percentage: null,
    performed_action: null
  },
  riskSummary: {
    id: null,
    pid: null,
    case: null,
    customer: null,
    time_horizon: null,
    required_return: null,
    risk_tolerance: null,
    risk_capacity: null,
    knowledge_level: null,
    recommended_risk_profile: null,
    time_horizon_interval: null
  },
  cipTemplate: [],
  cipFunds: []
};

export default createReducer(INITIAL_STATE, {
  [SET_POLICY]: (state, action) => {
    state.policy.id = action.payload.id;
    state.policy.owner = action.payload.owner;
    state.policy.number = action.payload.number;
    state.policy.type = action.payload.type;
    state.policy.provider = action.payload.provider;
    state.policy.platform = action.payload.platform;
    state.policy.fund_value = action.payload.fund_value;
    state.policy.transfer_value = action.payload.transfer_value;
    state.policy.family_linked = action.payload.family_linked;
    state.policy.fund_allocations = action.payload.fund_allocations;
    state.policy.charges = action.payload.charges;
    state.policy.wrap_retained = action.payload.wrap_retained;
    state.policy.wrap_percentage = action.payload.wrap_percentage;
    state.policy.advisor_charges_definitions =
      action.payload.advisor_charges_definitions;
    state.policy.performed_action = action.payload.performed_action;
  },
  [SET_RISK_SUMMARY]: (state, action) => {
    state.riskSummary.time_horizon = action.payload.time_horizon;
    state.riskSummary.time_horizon_interval =
      action.payload.time_horizon_interval;
    state.riskSummary.recommended_risk_profile =
      action.payload.recommended_risk_profile;
  },
  [CLEAN_STATE]: () => INITIAL_STATE,
  [SET_CIP_FUNDS]: (state, action) => {
    state.cipFunds = action.payload.results;
  },
  [SET_CIP_TEMPLATE]: (state, action) => {
    state.cipTemplate = action.payload.results;
  }
});
